import * as yup from 'yup';

export const validationSchema = () =>
  yup.object({
    date_start: yup.string(),
    date_finish: yup.string(),
    organizer: yup.object().nullable(true),
  });
